export function AudioIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.662 2.059l-4.61 1.536A3 3 0 0012 6.442v3.535a.9.9 0 000 .046v4.769c-.85-.507-1.894-.792-3-.792-1.3 0-2.515.394-3.428 1.079C4.658 15.764 4 16.786 4 18c0 1.214.658 2.236 1.572 2.921C6.485 21.606 7.7 22 9 22c1.3 0 2.515-.394 3.428-1.079C13.342 20.236 14 19.214 14 18v-7.28l3.949-1.315A3 3 0 0020 6.558V3.023a.99.99 0 00-.126-.509.995.995 0 00-1.034-.501.995.995 0 00-.178.046zM14 8.613l3.316-1.106A1 1 0 0018 6.558v-2.17l-3.316 1.105a1 1 0 00-.684.949v2.17zm-2.772 8.066c.535.4.772.878.772 1.321 0 .443-.237.92-.772 1.321C10.694 19.722 9.91 20 9 20c-.91 0-1.694-.278-2.228-.679C6.237 18.921 6 18.443 6 18c0-.443.237-.92.772-1.321C7.306 16.278 8.09 16 9 16c.91 0 1.694.278 2.228.679z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
